// App.js
import React from 'react';
import ChatApp from './components/ChatApp';
import './App.css';

function App() {
  return <ChatApp />;
}

export default App;
